import { createAction } from '@reduxjs/toolkit';

export const createFavouriteSuccess = createAction<void>('user/favourites/create/success');
export const createFavouriteError = createAction<unknown>('user/favourites/create/error');

export const updateFavouriteSuccess = createAction<void>('user/favourites/update/success');
export const updateFavouriteError = createAction<unknown>('user/favourites/update/error');

export const deleteFavouriteSuccess = createAction<void>('user/favourites/delete/success');
export const deleteFavouriteError = createAction<unknown>('user/favourites/delete/error');
